import React, { useEffect } from 'react';

import { Route, Routes, useLocation } from 'react-router-dom';

import Api from 'core/api';

import useFetch from 'hooks/useFetch';
import useRedirect from 'hooks/useRedirect';
import useUserRedux from 'hooks/useUserRedux';
import RedirectHelper from 'routes/MemberRoutes/RedirectHelper';
import getFullName from 'utils/getFullName';
import { ensureObject } from 'utils/objects';

import { GUARDIAN_MODE_KEY } from 'modules/AccountSetupV2/widgets/K12DashboardSwitcher/constants';

const MemberRedirects = () => {
  const location = useLocation();

  const { redirect } = useRedirect();
  const {
    isCounselorAndGuardian,
    data: { currentUserMode },
  } = useUserRedux();

  // Determines if member user needs to accept the terms of service
  const { data, isLoading } = useFetch({
    apiFunc: Api.slUsers.getMemberInfo,
    apiFuncName: 'slUsers.getMemberInfo',
    options: {
      enabled: currentUserMode ? currentUserMode === GUARDIAN_MODE_KEY : true,
    },
  });

  useEffect(() => {
    if (isLoading) return;
    const { needsToAcceptTermsOfService, user } = ensureObject(data);
    // If user needs to accept terms of service, redirects user to /onboarding
    // and displays TermsOfServiceScreen from OnboardingAndLogin
    if (needsToAcceptTermsOfService) {
      localStorage.setItem(
        'termsOfService',
        JSON.stringify({
          needsToAcceptTermsOfService,
          fullName: getFullName(user),
          redirectBackTo: location.pathname,
          buttonText: 'Continue',
        }),
      );
      redirect({
        to: '/onboarding',
        component: 'routes/MemberRoutes/MemberRedirects',
        reason: 'User needs to accept terms of service',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading]);

  return (
    <Routes>
      <Route
        path="/dashboard"
        element={
          <RedirectHelper isNewsfeedRedirect={!isCounselorAndGuardian} />
        }
      />
      <Route
        path="/"
        element={
          <RedirectHelper isNewsfeedRedirect={!isCounselorAndGuardian} />
        }
      />
    </Routes>
  );
};

export default MemberRedirects;
